/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Link } from 'gatsby';
import styled from '@emotion/styled';
import { ClassNames } from '@emotion/core';
import vars from '../styles/vars';
import SocialIcons from './SocialIcons';

const navItems = [
    { label: 'Home', path: '/' },
    {label: 'Events', path: '/events'},
    { label: 'Contact', path: '/contact' },
    { label: 'Volunteer', path: '/volunteer' },
    { label: 'Donate', path: '/donate' },
];

const Wrapper = styled('div')`
    background: ${vars.black};
    z-index: 10;
`;

const Nav = styled('nav')`
    transition: transform 0.3s ease-in-out;
    transform: translateX(-100%);
    position: fixed;

    &.expanded {
        transform: translateX(0%);
    }

    @media (min-width: ${vars.bpLargerThanTablet}) {
        bottom: 3rem;
        left: 3rem;
        transform: translateX(0%);
    }

    @media (min-width: ${vars.bpLargerThanDesktop}) {
        bottom: 5rem;
        left: 5rem;
    }

    @media (max-width: ${vars.bpLargerThanTablet}) {
        background-color: black;
        min-height: 100vh;
        width: 100vw;
        padding-top: 4rem;
        padding-left: 4rem;
    }
`;

const NavItems = styled('ol')`
    bottom: 0;
    font-family: ${vars.headingsFontFamily};
    font-weight: 600;
    list-style: none;
`;

const NavItem = (props) => (
    <li key={props.label}>
        <ClassNames>
            {({ css }) => (
                <Link
                    activeClassName={css`
                        color: ${vars.linkColor} !important;
                    `}
                    css={css`
                        color: ${vars.white};
                        text-decoration: none;
                        font-size: 4rem;
                        line-height: 1.2;

                        @media (min-width: ${vars.bpLargerThanTablet}) {
                            font-size: 3.5vw;
                            line-height: 1.1;
                        }

                        @media (min-width: ${vars.bpLargerThanDesktophd}) {
                            font-size: 3.5em;
                            line-height: 1.2;
                        }
                    `}
                    onClick={props.onLinkClick}
                    to={props.path}
                >
                    {props.label}
                </Link>
            )}
        </ClassNames>
    </li>
);

const Sidebar = (props) => (
    <Wrapper>
        <Nav className={`${props.in ? 'expanded' : ''}`}>
            <NavItems>
                {navItems.map((item) => {
                    return (
                        <NavItem
                            key={item.label}
                            onLinkClick={props.onLinkClick}
                            {...item}
                        />
                    );
                })}
            </NavItems>
            <div>
                <SocialIcons />
            </div>
        </Nav>
    </Wrapper>
);

export default Sidebar;
